import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"
import List from "app/stores/list"

export default class Store {
  @observable recoveryTableData = []
  @observable shareList = []
  @observable list
  @observable detailData = {}
  @observable versionType = ''
  @observable versions = []

  @action setVersionType = (type) => {
    this.versionType = type
  }

  @action getVersions = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/versions`)
      .checkToken()
      .commonDispose()
  }

  @action getGroupsTemp = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/template`)
      .checkToken()
      .commonDispose()
  }

  @action setVersions = (versions) => {
    this.versions = versions
  }

  @action clearVersions = () => {
    this.versions = []
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action clearDetailData = () => {
    this.detailData = {}
  }

  @action getExportUrl = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/statistic`)
      .checkToken()
      .commonDispose()
  }

  @action downloadStep1 = (groupId, templateId, versionId) => {
    return request.post(
      `${config.backend}/pgs/reports/preview/${groupId}/group/download?templateId=${templateId}&versionId=${versionId}`
    )
      .checkToken()
      .commonDispose()
  }

  @action downloadStep2 = (downloadId) => {
    return request.get(`${config.backend}/pgs/reports/pdf/${downloadId}/status`)
      .checkToken()
      .commonDispose()
  }

  @action shareGroup = (groupId, username) => {
    return request.put(`${config.backend}/pgs/groups/${groupId}/share/${username}`)
      .checkToken()
      .commonDispose()
  }

  @action dataSwitch = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action deleteReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/pgs/groups/${groupId}/reports/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action recoveryReport = (groupId, reportId) => {
    return request.put(`${config.backend}/pgs/groups/${groupId}/reports/${reportId}/recovery`)
      .checkToken()
      .commonDispose()
  }

  @action getHistory = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/history`)
      .checkToken()
      .commonDispose()
  }

  /*
   * @query: 获取数据的类型
   */
  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/reports?state=${query}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.recoveryTableData = res
        }
      )
  }

  @action clearRecoveryTableData = () => {
    this.recoveryTableData = []
  }

  @action updateGroup = (groupId, groupName) => {
    return request.put(`${config.backend}/pgs/groups/${groupId}/reports`)
      .send({ groupName })
      .checkToken()
      .commonDispose()
  }

  @action getReportByAppId = (appId) => {
    return request.get(`${config.backend}/pgs/reports/apps/${appId}`)
      .checkToken()
      .commonDispose()
  }

  @action getSearchData = (appId, keyword) => {
    return request.get(`${config.backend}/pgs/reports/apps/${appId}?keywords=${keyword}`)
      .checkToken()
      .commonDispose()
  }

  @action createNewGroup = (newGroupData) => {
    return request.post(`${config.backend}/pgs/groups/reports`)
      .send(newGroupData)
      .checkToken()
      .commonDispose()
  }

  @action deleteGroup = (id) => {
    return request.delete(`${config.backend}/pgs/groups/${id}/reports`)
      .checkToken()
      .commonDispose()
  }

  @action getShareList = (id) => {
    return request.get(`${config.backend}/pgs/groups/${id}/share`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.shareList = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action cancelShare = (groupId, ownerId, type) => {
    if (type === 'toId') {
      return request.delete(`${config.backend}/pgs/groups/${groupId}/share?${type}=${ownerId}`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            const index = this.shareList.findIndex(
              shared => {
                return shared.toId === ownerId
              }
            )
            this.shareList.splice(index, 1)
            message.success("取消分享成功")
            return Promise.resolve()
          },
          err => {
            message.error(err.message)
            return Promise.reject()
          }
        )
    } else {
      return request.delete(`${config.backend}/pgs/groups/${groupId}/share`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            this.list.filterData()
            message.success("取消分享成功")
            return Promise.resolve()
          },
          err => {
            message.error(err.message)
            return Promise.reject()
          }
        )
    }
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "pgs/groups/reports")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/pgs/report.js